/* @flow */
import React from 'react';

import cx from 'classnames';

import './styles/HovercardBody.scss';

class HovercardBody extends React.Component {
  render() {
    return (
      <div {...this.props} className={cx('HovercardBody', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default HovercardBody;



// WEBPACK FOOTER //
// ./src/components/HovercardBody.jsx